export default function FeedbackInDelegation() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Обратная связь при делегировании
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Делегирование невозможно отделить от обратной связи. Без неё сотрудник не понимает, насколько хорошо выполнена задача и что можно улучшить.
        </p>

        <div className="grid sm:grid-cols-2 gap-5 mb-10">
          {[
            { title: 'Как реагировать на ошибки', desc: 'Не «Кто так делает?!», а «Давай разберём, что пошло не так и как сделать лучше в следующий раз». Ошибка — это информация для улучшения, а не повод для наказания.' },
            { title: 'Как не забирать задачу обратно', desc: 'Если результат не идеален, не говорите «ладно, я сам». Объясните, что именно нужно исправить, дайте сотруднику возможность доработать задачу самостоятельно.' },
            { title: 'Как корректировать действия', desc: 'Корректировка должна быть конкретной: «В отчёте не хватает данных за март — добавь. График лучше сделать линейным, а не столбчатым — переделай».' },
            { title: 'Как обсуждать результат', desc: 'Начинайте с того, что получилось хорошо, затем — что можно улучшить, и завершайте договорённостью о следующих шагах. Это делает обратную связь конструктивной.' },
            { title: 'Как формировать самостоятельность', desc: 'Постепенно переходите от «я скажу, как исправить» к «как ты сам думаешь, что можно улучшить?». Это развивает аналитическое мышление сотрудника.' },
            { title: 'Регулярность обратной связи', desc: 'Не ждите formal performance review. Давайте обратную связь сразу после завершения задачи или контрольной точки. Своевременность критически важна.' },
          ].map((item) => (
            <div key={item.title} className="bg-white rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors">
              <h3 className="font-bold text-gray-900 text-sm mb-1.5">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-3xl mx-auto text-center">
          <p className="text-sm md:text-base text-teal-800 leading-relaxed font-semibold">
            Ошибка сотрудника не всегда означает, что делегирование было неправильным. Иногда это часть развития компетенции. Важно не наказывать за ошибки, а использовать их для обучения.
          </p>
        </div>
      </div>
    </section>
  );
}